import { pick, uniqueId } from 'lodash';

import {
  formatCurrency,
  transformIncluded,
  parseNumber,
} from 'modules/common/utils';

export const transformGetRecentTransactions = (data) => {
  const keys = [
    'order_number',
    'subtotal',
    'subtotal_human',
    'table_number',
    'uuid',
  ];

  const $data = data?.attributes || data;
  const { subtotal } = $data || {};

  const args = {
    ...$data,
    subtotal_human: formatCurrency(subtotal),
    id: data?.id || uniqueId(),
  };

  return pick(args, keys);
};

export const transformGetVariant = (data) => {
  const keys = [
    'id',
    'barcode',
    'code',
    'created_at',
    'dimensions',
    'discounted_price',
    'is_active',
    'photo_url',
    'price',
    'product_cost',
    'product_uuid',
    'sku',
    'updated_at',
    'uuid',
    'vendor_uuid',
    'weight',
  ];

  const args = {
    ...data?.attributes,
    id: data?.id || uniqueId(),
  };

  return pick(args, keys);
};

export const transformAddons = (data) => {
  const keys = [
    'id',
    'addon_group_uuid',
    'created_at',
    'name',
    'price',
    'quantity',
    'updated_at',
    'uuid',
  ];

  const args = {
    ...data?.attributes,
    id: data?.id,
  };

  return pick(args, keys);
};

export const transformGetProducts = ($data, $included) => {
  const { included, ...data } = transformIncluded($data, $included || []) || {};
  const keys = [
    'barcode',
    'code',
    'created_at',
    'description',
    'discount',
    'name',
    'photo_url',
    'price',
    'price_human',
    'product_uuid',
    'product_variant_uuid',
    'quantity',
    'sku',
    'addons',
    'updated_at',
    'uuid',
    'variants',
  ];

  const { variants, addOns } = included || {};
  const { price } = data?.attributes || {};

  const $variants = variants ? transformGetVariant(variants) : {};

  const args = {
    ...data?.attributes,
    variants: $variants,
    price_human: formatCurrency(parseNumber(price)),
    addons: addOns?.map(transformAddons),
    id: data?.id || uniqueId(),
  };

  return pick(args, keys);
};

export const transformGetSelectedRecentTransactions = ($data, $included) => {
  const { included, ...data } = transformIncluded($data, $included || []) || {};
  const keys = [
    'created_at',
    'cart',
    'payment_method',
    'service_charge',
    'amount_tendered',
    'total_discount',
    'change',
    'subtotal',
    'tax',
    'total',
  ];

  const { products } = included || {};
  const { total, tax, payment_method, discount, subtotal } =
    data?.attributes || {};
  const cart = products?.map((item) => transformGetProducts(item, $included));

  const args = {
    ...data?.attributes,
    cart,
    subtotal: parseNumber(subtotal || 0) + parseNumber(discount || 0) || 0,
    total_discount: discount,
    total: parseNumber(total || 0) + parseNumber(discount || 0),
    tax: parseNumber(tax),
    payment_method:
      payment_method === 'CASH_ON_DELIVERY' ? 'CASH' : payment_method,
    id: data?.id || uniqueId(),
  };

  return pick(args, keys);
};
